
export const BASE_WP_URL = 'https://blog.together-ads.com';
export const NUMBER_OF_POSTS_SLIDE = 5;
export const SHARE_LINK_INSTAGRAM = 'https://www.instagram.com/';
export const SHARE_LINK_TWITTER = 'https://twitter.com/intent/tweet?url=';
export const SHARE_LINK_LINKEDIN = 'https://www.linkedin.com/sharing/share-offsite/?url=';